import { defineStore } from "pinia";
import type { SiteUrlResponse } from "shared-core/types/integrations/wordpress";
import type { SuperAdminCountResponse } from "shared-core/types/user";
import type { WordpressIntegrationStore } from "../types/wordpress-integration-store";
import { useApi } from "../utils/api";

export const useWordpressIntegrationStore = defineStore(
  "wordpressIntegration",
  {
    state: () => ({
      superAdminCount: null,
      siteUrl: null,
    }),
    actions: {
      async fetchSuperAdminCount(): Promise<void> {
        const response = await useApi().get<SuperAdminCountResponse>(
          "integrations/wordpress/super-admin-count",
        );
        this.superAdminCount = (await response.data).count;
      },

      async fetchSiteUrl(): Promise<string> {
        const response = await useApi().get<SiteUrlResponse>(
          "integrations/wordpress/site-url",
        );
        const url = (await response.data).url;
        this.siteUrl = url;

        return url;
      },
    } satisfies ThisType<WordpressIntegrationStore>,
    getters: {},
  },
);
